import { post } from "./http";
let basic = "/product";
const goodsApi = {
  getList: (params) => {
    return post(`${basic}/nglistCommodity`, params);
  }, //产品信息查询
  getCommodityById: (params) => {
    return post(`${basic}/getCommodityById`, params);
  },
  queryListByInfoType: params => { return post(`${basic}/listHomeCommodity`, params); },  //商品组-组内可选商品查询
};
export default goodsApi;
